import { render, staticRenderFns } from "./ItemRentStockAvailability.vue?vue&type=template&id=4072ebd6&scoped=true&"
import script from "./ItemRentStockAvailability.vue?vue&type=script&lang=js&"
export * from "./ItemRentStockAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ItemRentStockAvailability.vue?vue&type=style&index=0&id=4072ebd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4072ebd6",
  null
  
)

export default component.exports